import {
  SCHEDULE_LIST,
  SCHEDULE_DETAILS,
  SCHEDULE_CANCEL,
  SCHEDULE_PO_LIST,
  SCHEDULED_RIDES_LIST,
  SCHEDULED_RIDES_CANCEL,
  SCHEDULED_RIDES_UPDATE,
} from 'App/store/constants';

const initialState = {
  // corporate schedule
  list: [] as any[],
  poList: [] as any[],
  scheduleDetails: {} as any,
  errors: {} as any,
  loading: false,
  // Phase 1 — rider-owned scheduled rides from c_scheduled_rides
  scheduledRides: [] as any[],
  scheduledRidesLoading: false,
  scheduledRidesError: null as string | null,
  scheduledRidesTotal: 0,
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    // ── corporate schedule ─────────────────────────────────────────────────
    case SCHEDULE_LIST.PENDING:
      return { ...state, list: [], loading: true };
    case SCHEDULE_LIST.SUCCESS:
      return { ...state, list: action.payload?.data || [], loading: false };
    case SCHEDULE_LIST.FAILURE:
      return { ...state, list: [], errors: action.payload };

    case SCHEDULE_PO_LIST.PENDING:
      return { ...state, loading: true };
    case SCHEDULE_PO_LIST.SUCCESS:
      return { ...state, loading: false, poList: action.payload.data };
    case SCHEDULE_PO_LIST.FAILURE:
      return { ...state, loading: false };

    case SCHEDULE_DETAILS.PENDING:
      return { ...state, loading: true };
    case SCHEDULE_DETAILS.SUCCESS:
      return { ...state, loading: false, scheduleDetails: action.payload.data };
    case SCHEDULE_DETAILS.FAILURE:
      return { ...state, loading: false };

    case SCHEDULE_CANCEL.PENDING:
      return { ...state, loading: true };
    case SCHEDULE_CANCEL.SUCCESS:
      return { ...state, scheduleDetails: action.payload.data || null, loading: false };
    case SCHEDULE_CANCEL.FAILURE:
      return { ...state, poList: null, loading: false, errors: action.payload };

    // ── Phase 1 rider scheduled rides ─────────────────────────────────────
    case SCHEDULED_RIDES_LIST.PENDING:
      return { ...state, scheduledRidesLoading: true, scheduledRidesError: null };
    case SCHEDULED_RIDES_LIST.SUCCESS: {
      const payload = action.payload?.data || action.payload || {};
      const rows = Array.isArray(payload) ? payload : (payload.data || []);
      return {
        ...state,
        scheduledRidesLoading: false,
        scheduledRides: rows,
        scheduledRidesTotal: payload.total || rows.length,
      };
    }
    case SCHEDULED_RIDES_LIST.FAILURE:
      return { ...state, scheduledRidesLoading: false, scheduledRidesError: action.payload };

    case SCHEDULED_RIDES_CANCEL.PENDING:
      return { ...state, scheduledRidesLoading: true };
    case SCHEDULED_RIDES_CANCEL.SUCCESS: {
      const cancelledId = action.payload?.data?.schedule_id;
      const updated = cancelledId
        ? state.scheduledRides.map((r: any) =>
            String(r.id) === String(cancelledId) ? { ...r, status: 'cancelled' } : r
          )
        : state.scheduledRides;
      return { ...state, scheduledRidesLoading: false, scheduledRides: updated };
    }
    case SCHEDULED_RIDES_CANCEL.FAILURE:
      return { ...state, scheduledRidesLoading: false, scheduledRidesError: action.payload };

    case SCHEDULED_RIDES_UPDATE.PENDING:
      return { ...state, scheduledRidesLoading: true, scheduledRidesError: null };
    case SCHEDULED_RIDES_UPDATE.SUCCESS: {
      const data = action.payload?.data || {};
      const updatedId = data.schedule_id;
      const updated = updatedId
        ? state.scheduledRides.map((r: any) =>
            String(r.id) === String(updatedId) ? { ...r, ...data } : r
          )
        : state.scheduledRides;
      return { ...state, scheduledRidesLoading: false, scheduledRides: updated };
    }
    case SCHEDULED_RIDES_UPDATE.FAILURE:
      return { ...state, scheduledRidesLoading: false, scheduledRidesError: action.payload };

    default:
      return state;
  }
};

export default reducer;
